import { DeviceExtraDetailsWebComponent } from './component/DeviceExtraDetailsWebComponent';

export { DeviceExtraDetailsWebComponent };
